import $ from 'jquery';
import {
  getPasswordRegex,
  getPasswordRegexMessage,
} from '../user/changePasswordValidator';

function depends() {
  $(this).val($.trim($(this).val()));
  return true;
}

export const validateEmail = () => {
  $('#user_email, #admin_email').rules('add', {
    required: {
      depends,
    },
    regex: /^([\w.%+-]+)@([\w.-]+\.+[\w]{2,})$/,
    email: true,
    messages: {
      required: 'メールアドレスは必須項目です。',
      regex: 'メールアドレスの形式は正しくありません。',
      email: 'メールアドレスの形式が正しくありません。',
    },
  });
};

// UserPasswordClientSideValidationHelperと組み合わせて使用する
export const validatePassword = () => {
  const strictPasswordValidation = $('#user_password').hasClass(
    'strict-password-validation',
  );
  $('#user_password').rules('add', {
    required: true,
    regex: getPasswordRegex({ strictPasswordValidation }),
    messages: {
      required: 'パスワードは必須項目です。',
      regex: getPasswordRegexMessage({ strictPasswordValidation }),
    },
  });

  $('#admin_password').rules('add', {
    required: true,
    regex: getPasswordRegex({ strictPasswordValidation: true }),
    messages: {
      required: 'パスワードは必須項目です。',
      regex: getPasswordRegexMessage({ strictPasswordValidation: true }),
    },
  });
};

export const validatePasswordSignIn = () => {
  $('#user_password, #admin_password').rules('add', {
    required: true,
    messages: {
      required: 'パスワードは必須項目です。',
    },
  });
};

export const validatePasswordConfirmation = () => {
  $('#user_password_confirmation').rules('add', {
    required: true,
    equalTo: '#user_password',
    messages: {
      required: 'パスワードの確認は必須項目です。',
      equalTo: '確認用パスワードとパスワードが一致しません。',
    },
  });
  $('#admin_password_confirmation').rules('add', {
    required: true,
    equalTo: '#admin_password',
    messages: {
      required: 'パスワードの確認は必須項目です。',
      equalTo: '確認用パスワードとパスワードが一致しません。',
    },
  });
};
